import { useSequencerClock } from '../../../hooks/scheduling/Sequencer';
import { useClockState } from '../hooks';
export function usePracticeClock(timing, sequencerConfig) {
    const { clock, sequencer } = useSequencerClock(sequencerConfig);
    const clockState = useClockState(clock, timing);
    return { clock, sequencer, clockState };
}
//# sourceMappingURL=practiceClock.js.map